import React from "react";
import "./Button.scss";

export default function Button({
  text,
  className,
  href,
  newTab,
  download,
  analyticsLabel
}) {
  const linkProps = {};
  if (newTab) {
    linkProps.target = "_blank";
    linkProps.rel = "noopener noreferrer";
  }
  if (download !== undefined && download !== null && download !== false) {
    linkProps.download = typeof download === "string" ? download : "";
  }
  return (
    <div className={className}>
      <a
        className="main-button"
        href={href}
        data-analytics-label={analyticsLabel || text}
        {...linkProps}
      >
        {text}
      </a>
    </div>
  );
}
